import axios from '@/axiosInterceptor';

const state = () => ({
  invitations: [],
});

// getters
const getters = {};

// actions
const actions = {
  async createCarrierInvitation(_, body) {
    try {
      if (body.email) {
        delete body['user_id_for_email'];
      } else {
        delete body.email;
      }

      let res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/connection_invitations',
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async resendCarrierInvitation(_, { invitationId, classifications }) {
    let body = {
      connection_invitation: {
        classification_ids: classifications,
      },
    };
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY +
          `/api/v1/connection_invitations/${invitationId}/resend`,
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarrierInvitations({ commit }, payload) {
    try {
      const { brokerId, carrierId } = payload;
      const params = {
        'q[issuer_id_eq]': brokerId,
        'q[carrier_id_eq]': carrierId,
      };
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/connection_invitations',
        { params }
      );

      if ([200, 201].includes(res.status) && res.data)
        commit('setCarrierInvitations', res.data);

      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

const mutations = {
  setCarrierInvitations(state, invitations) {
    state.invitations = invitations;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
